import { render, staticRenderFns } from "./Livejobs.vue?vue&type=template&id=5d5a3d7a&"
import script from "./Livejobs.vue?vue&type=script&lang=js&"
export * from "./Livejobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports